var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"introduce"},[_c('div',{staticClass:"common-wrap",style:(_vm.banner)},[_vm._t("default"),_c('div',{staticClass:"desc",domProps:{"innerHTML":_vm._s(_vm.desc)}})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }